import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackingAPI } from '../services/api';

// Generate a unique session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('visitor_session_id');
  if (!sessionId) {
    sessionId = 'sess_' + Math.random().toString(36).substring(2) + Date.now().toString(36);
    sessionStorage.setItem('visitor_session_id', sessionId);
  }
  return sessionId;
};

export const useVisitorTracking = () => {
  const location = useLocation();
  const trackedPages = useRef(new Set());

  useEffect(() => {
    // Don't track admin pages
    if (location.pathname.startsWith('/admin')) {
      return;
    }

    // Create unique key for this page visit
    const pageKey = `${location.pathname}_${Date.now()}`;
    
    // Prevent duplicate tracking within same render cycle
    if (trackedPages.current.has(location.pathname)) {
      return;
    }
    trackedPages.current.add(location.pathname);

    // Track the visit
    const trackVisit = async () => {
      try {
        const visitData = {
          sessionId: getSessionId(),
          page: location.pathname || '/',
          pageTitle: document.title,
          referrer: document.referrer || null,
          screenWidth: window.screen.width,
          screenHeight: window.screen.height,
          language: navigator.language,
          userAgent: navigator.userAgent,
        };

        await trackingAPI.trackVisit(visitData);
      } catch (error) {
        // Silently fail - don't interrupt user experience
        console.warn('Visit tracking failed:', error);
      }
    };

    // Small delay to ensure page is loaded
    const timeoutId = setTimeout(trackVisit, 100);

    return () => {
      clearTimeout(timeoutId);
      // Remove from tracked pages after a delay to allow re-tracking on navigation
      setTimeout(() => {
        trackedPages.current.delete(location.pathname);
      }, 1000);
    };
  }, [location.pathname]);
};

export default useVisitorTracking;
